// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__lV2sv","cell":"ColumnAccessor_cell__3UdZy","firstCellAccent":"ColumnAccessor_firstCellAccent__3ltl2"};